export default "__VITE_ASSET__DvBhkVqJ__"